import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX = 6;

/** Pick up to 6 products to embed as photo cards in the newsletter email. */
export const NewsletterProductPicker = ({ selected, onChange }) => {
  const [articles, setArticles] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    axios.get(`${API}/articles`).then((r) => {
      const list = Array.isArray(r.data) ? r.data : r.data.articles || [];
      setArticles([...list].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || "")));
    }).catch(() => setArticles([]));
  }, []);

  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    return (s ? articles.filter((a) => (a.title || "").toLowerCase().includes(s)) : articles).slice(0, 40);
  }, [articles, q]);

  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else if (selected.length < MAX) onChange([...selected, id]);
  };
  const byId = Object.fromEntries(articles.map((a) => [a.id, a]));

  return (
    <div className="mb-4" data-testid="newsletter-product-picker">
      <label className="block text-sm font-medium text-gray-700 mb-2">Prodotti in evidenza (foto + prezzo + bottone) — max {MAX}</label>
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-2" data-testid="newsletter-selected-products">
          {selected.map((id) => (
            <span key={id} className="inline-flex items-center gap-1 bg-pink-50 text-pink-700 border border-pink-200 text-xs font-semibold px-2 py-1 rounded-full">
              {byId[id]?.title?.slice(0, 40) || id}
              <button type="button" onClick={() => toggle(id)} className="font-bold" data-testid={`newsletter-remove-product-${id}`}>×</button>
            </span>
          ))}
        </div>
      )}
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca prodotto per nome…"
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm mb-2" data-testid="newsletter-product-search" />
      <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg divide-y" data-testid="newsletter-product-list">
        {shown.map((a) => (
          <label key={a.id} className={`flex items-center gap-2 px-3 py-1.5 text-sm cursor-pointer ${selected.includes(a.id) ? "bg-pink-50" : "hover:bg-gray-50"}`} data-testid={`newsletter-product-${a.id}`}>
            <input type="checkbox" checked={selected.includes(a.id)} onChange={() => toggle(a.id)} disabled={!selected.includes(a.id) && selected.length >= MAX} />
            {(a.images_url?.[0] || a.photo_url) && <img src={a.images_url?.[0] || a.photo_url} alt="" className="w-8 h-8 object-contain rounded bg-gray-100" />}
            <span className="truncate flex-1 text-gray-800">{a.title}</span>
            {a.preorder_date && a.preorder_date > new Date().toISOString().slice(0, 10) && <span className="text-[10px] font-bold text-pink-600">PREVENDITA</span>}
            <span className="text-xs text-gray-500">€{(Number(a.price || 0) * (1 + Number(a.iva_percentage || 0) / 100)).toFixed(2)}</span>
          </label>
        ))}
        {shown.length === 0 && <p className="text-xs text-gray-400 p-3">Nessun prodotto trovato</p>}
      </div>
    </div>
  );
};
